module.exports = __webpack_public_path__ + "efd7bfc5e86db008d3e3348f91a46f4f.svg";